<ul class="list">
    @for (item of metaMenuLinks; track $index; ) {
        <li class="list-item"
            [ngClass]="{
            'd-sm-none': $first,
            'd-md-block': $first,
        }">
            @if ((item.link | isClubMemberPage : 'clubPage' | async) === false) {
                <a class="link" [routerLink]="item.link.url">
                    <span class="kk-visuallyhidden">
                        {{ 'general.accessibility.goTo' | translateSafe: { destination: item.link.name } }}
                    </span>
                    <img
                        class="icon"
                        [src]="item.icon?.src"
                        [alt]="item.icon?.name"
                        [width]="item.icon?.width"
                        [height]="item.icon?.height"
                    />
                    <span class="d-none d-md-block kk-overflow-ellipsis text">
                        {{ item.link.name }}
                    </span>
                </a>
            } @else {
                <app-club-member-link [item]="item"></app-club-member-link>
            }
        </li>
    }
</ul>
